import API from '../../../../../services/api';

export const AVISOS_STOCK_API = {
    get: async (page = 1, search = null) => {
        return await API.get(`/avisos-stock?page=${page}${search || ''}`).then(res => res.data);
    },
    new: async (aviso) => {
        return API.post('/avisos-stock', aviso).then(res => res.data);
    },
    update: async (aviso) => {
        return API.put('/avisos-stock/' + aviso.id, aviso).then(res => res.data);
    }
}